module.exports = __webpack_public_path__ + "static/img/super-chat-pass.b97b1d44.png";